import React from "react"
import Img from "gatsby-image/withIEPolyfill"

export default ({ image }) => (
  <div id="grid-image">
    {image && <Img fluid={image.childImageSharp.fluid} className="grid-image"/>}
  </div>
)
